"use strict";

exports.__esModule = true;

function padSeconds(seconds) {
  return ('0' + seconds).slice(-2);
}

function toClockParts(ms, disablePadding) {
  var total = Math.ceil(ms / 1000);
  var minutes = Math.floor(total / 60);
  var seconds = total - minutes * 60;
  return {
    total: total,
    minutes: minutes,
    seconds: disablePadding ? seconds : padSeconds(seconds)
  };
}

exports.toClockParts = toClockParts;
var separator = ':';

function clockTime(ms, seconds) {
  if (Number.isInteger(seconds)) {
    return ms + separator + padSeconds(seconds);
  }

  var clockParts = toClockParts(ms);
  return clockParts.minutes + separator + clockParts.seconds;
}

exports.clockTime = clockTime;
exports["default"] = clockTime;